import { createRouter, createWebHistory } from 'vue-router'
// import App from '../App.vue'
import Main from '../views/Main'
// import Recycle from '../views/Recycle.vue'


const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/spl',
    name: 'VycvikVetrone',
    component: () => import('../views/PageGldVycvik.vue')
  },
  {
    path: '/ull',
    name: 'VycvikUll',
    component: () => import('../views/PageUllVycvik.vue')
  },
  {
    path: '/kontakty',
    name: 'Kontakty',
    component: () => import('../views/PageKontakt.vue')
  },
  {
    path: '/zazitkovelety',
    name: 'VyhlidkoveLety',
    component: () => import('../views/PageVyhlidkoveLety.vue')
  },
  {
    path: '/clenstvi',
    name: 'Clenstvi',
    component: () => import('../views/PageClenstvi.vue')
  },
  {
    path: '/send_post.php',
    name: 'mailphp',
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  scrollBehavior: function(to) {
      if (to.hash) {
          return {
            el: to.hash,
            top: 95
          }
      } else {
          return { x: 0, y: 0 }
      }
  },
  routes,
})

export default router
